// Footer.js

import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Instagram, WhatsApp, Facebook } from '@mui/icons-material';
import logo from '../images/inverted_image.png'


const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        color: 'white',
        padding: '20px',
        textAlign: 'center',
        
        bottom: 0,
        maxWidth: "100vw",
      }}
    >
      <Grid container spacing={7}>
        <Grid item xs={9} md={5} sx={{ margin: '0 auto' }}>
          <img
            src={logo}
            alt=""
            style={{ maxWidth: '50px', maxHeight: '50px' }}
          />
          <Typography
            sx={{
              fontSize: "28px",
              color: 'white',
              fontWeight: 'bold'
            }}>
            CHRONIC PEST CONTROL AGENCIES
          </Typography>
          <Typography
            sx={{
              fontSize: "18px",
              color: 'white',
            }}>
            Pest control is essential for maintaining a healthy and safe environment in homes and businesses. It involves the management and elimination of pests like rodents, insects, and termites, which can cause damage to property and spread diseases.</Typography>
        </Grid>
        <Grid item xs={9} md={3} sx={{ margin: '0 auto' }}>
          <Typography
            sx={{
              fontSize: "24px",
              borderBottom: "1px solid white",
              marginBottom: 2
            }}>
            Go To
          </Typography>
          <Typography>
            Home
          </Typography>
          <Typography>
            About Us
          </Typography>
          <Typography>
            How we do it
          </Typography>
        </Grid>
        <Grid item xs={9} md={3} sx={{ margin: '0 auto' }}>
          <Typography
            sx={{
              fontSize: "24px",
              borderBottom: "1px solid white",
              marginBottom: 2
            }}>
            Contact us
          </Typography>

          <Typography>
            +91 94564 86286
          </Typography>
          <Typography
            sx={{

              fontSize: '12px'
            }}>
            support@chronicpestcontrolagencies.org
          </Typography>
          <Typography>
            Kota,india
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: "8px",
              marginTop: '14px',
              justifyContent: 'center'
            }}
          >
            <Instagram style={{ fontSize: '30px', color: 'white' }} />
            <WhatsApp style={{ fontSize: '30px', color: 'white' }} />
            <Facebook style={{ fontSize: '30px', color: 'white' }} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
 